import store from '@/store'

store.subscribe((mutation) => {

    switch (mutation.type) {
        case 'auth/SET_TOKEN':
            if (mutation.payload) {
                localStorage.setItem('token', mutation.payload)
            } else {
                debugger// eslint-disable-line no-debugger 
                localStorage.removeItem('token')
            }

            break;
    }
})